import { Component, Input, OnInit } from '@angular/core'
import { QuotationModel } from '../../../models/quotation.model'
import { CommonModule } from '@angular/common'
import { NavigationExtras, Router } from '@angular/router'
import { AuthStateService } from '../../../../../auth-state.service'

@Component({
  selector: 'app-otherquotations',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './otherQuotations.component.html',
  styleUrl: './otherQuotations.component.css',
})
export class OtherquotationsComponent implements OnInit {
  @Input() otherActiveQuotations: QuotationModel[] | undefined
  @Input() currentQuotationId: number | undefined

  filteredQuotations: QuotationModel[] | undefined
  permissions: string[] = []

  constructor(private router: Router, private authStateService: AuthStateService,) {
    this.authStateService.permissions.subscribe((permList) =>{
      this.permissions = permList
    })

  }
  ngOnInit(): void {
    
    this.filteredQuotations = this.otherActiveQuotations?.filter(
      (quot) => quot.quotationFields.id !== this.currentQuotationId,
    )
  }

  viewQuotation(quot: QuotationModel) {
    

    const navigationExtras: NavigationExtras = {
      state: {
        mode: 'update',
        quotationFields: JSON.stringify(quot.quotationFields),
        quotationItems: JSON.stringify(quot.quotationItems),
        quotationTerms: JSON.stringify(quot.quotationTerms),
        otherQuotations: this.otherActiveQuotations,
      },
    }
    this.router.navigate(
      ['/viewQuotationDetails', quot.quotationFields.id],
      navigationExtras,
    )
  }

  hasPermission(stage: string): boolean {
    let perm: string = 'Quotations'
    if(stage == 'publish'){
      perm += 'PublishedListPermission'
    }else if(stage === 'draft'){
      perm += 'DraftListPermission'
    }else if(stage === 'proforma'){
      perm +=  'ProformaListPermission'
    }
    return this.permissions.includes(perm)
  }
}
